export default __webpack_public_path__ + "static/media/unhappywall.8b87cc8f.JPG";